import { jsx as _jsx } from "react/jsx-runtime";
import CurrencyContext from '../contexts/CurrencyContext';
import { usePersistedCurrencyPreference } from '../hooks/usePersistedCurrencyPreference';
const CurrencyContextProvider = ({ children }) => {
    const { selectedCurrency, isSecondaryCurrencyDisplay, setIsSecondaryCurrencyDisplay, } = usePersistedCurrencyPreference();
    return (_jsx(CurrencyContext.Provider, { value: {
            selectedCurrency: selectedCurrency ?? '',
            isSecondaryCurrencyDisplay,
            setIsSecondaryCurrencyDisplay,
        }, children: children }, void 0));
};
export default CurrencyContextProvider;
//# sourceMappingURL=CurrencyContextProvider.js.map